import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW } from "const"
import { OkrSession } from "server/models"
import { okrSessionsRoute } from "client/parts/routes"
import { forceRerenderContent } from "client/utils"
import {
    StoreType,
    setOkrSessionPopupMenuTarget,
    setOkrSessionPopupMenuShow,
    setOkrSessionActive,
} from "client/store"
import {
    Link,
    UserIcon,
    DateFormatter,
    TableColumn,
    TableMenu,
} from "client/components"
import {
    SessionTitleWrapper,
    SessionDurationWrapper,
    SessionDurationDelimeter,
} from "../styled"


const Columns = () => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const sessionLink = (session: OkrSession, linkContent: any) => {
        const href = `${okrSessionsRoute}/${VIEW}/${session.id}`
        return (
            <Link
                href={href}
                onClick={() => forceRerenderContent(href, dispatch)}
            >
                {linkContent}
            </Link>
        )
    }

    const showContextMenu = (
        e: React.MouseEvent,
        active: OkrSession,
    ) => {
        e.preventDefault()
        e.stopPropagation()

        dispatch(setOkrSessionPopupMenuTarget(e.currentTarget as HTMLElement))
        dispatch(setOkrSessionPopupMenuShow(true))
        dispatch(setOkrSessionActive(active))
    }

    const columns: TableColumn[] = [
        {
            field: "menu",
            formatter: (session: OkrSession) => <TableMenu onClick={(e) => showContextMenu(e, session)} />,
        },
        {
            field: "name",
            header: lang.name,
            collapsible: true,
            showCollapseButton: false,
            cellMinWidth: "350px",
            cellMaxWidth: "350px",
            formatter: (session: OkrSession) => (
                <SessionTitleWrapper>
                    { sessionLink(session, session.name) }
                    <SessionDurationWrapper>
                        <DateFormatter date={session.dateStart} showTime={false} />
                        <SessionDurationDelimeter>—</SessionDurationDelimeter>
                        <DateFormatter date={session.dateEnd} showTime={false} />
                    </SessionDurationWrapper>
                </SessionTitleWrapper>
            ),
        },
        {
            field: "owner",
            header: lang.owner,
            cellMaxWidth: "150px",
            formatter: (session: OkrSession) => {
                const user = userList[session.owner]
                return <UserIcon user={user} size="sm" />
            },
        },
        {
            field: "status",
            header: lang.status,
            cellMinWidth: "100px",
            formatter: (session: OkrSession) => lang[session.status],
        },
    ]

    return columns
}
export default Columns
